import { HttpClient, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { PRODUCTS_SERVICE_URL } from 'src/app/injection-tokens';
import { Observable } from 'rxjs';
import { DownloadGenerateResponse, DownloadListResponse } from './download-job.model';

@Injectable({
  providedIn: 'root',
})
export class ProductDownloadsService {
  private readonly baseUrl: string;

  constructor(
    @Inject(PRODUCTS_SERVICE_URL) baseServiceUrl: string,
    readonly http: HttpClient
  ) {
    this.baseUrl = baseServiceUrl + '/downloads';
  }

  generateDownload(downloadType: string): Observable<DownloadGenerateResponse> {
    return this.http.post<DownloadGenerateResponse>(`${this.baseUrl}/${downloadType}/generate`, null);
  }

  getAllDownloads(): Observable<DownloadListResponse> {
    return this.http.get<DownloadListResponse>(this.baseUrl);
  }

  getDownloads(downloadType: string): Observable<DownloadListResponse> {
    return this.http.get<DownloadListResponse>(`${this.baseUrl}/${downloadType}`);
  }

  downloadFile(downloadType: string, jobId: string): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.baseUrl}/${downloadType}/${jobId}/file`, {
      responseType: 'blob',
      observe: 'response',
    });
  }
}
